import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        redirect: '/home',
        component: () => import('@/vue-pages/pages/home') // 默认路由
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('@/vue-pages/pages/home'), // 首页
        meta: {
            title: '首页',
            keepAlive: true
        }
    },
    {
        path: '/orders',
        name: 'order',
        component: () => import('@/vue-pages/pages/order'), // 订单
        meta: {
            title: '订单',
            keepAlive: true
        }
    },
    {
        path: '/order', // 旧路径兜底，保留分享出去的旧链接可用
        redirect: to => ({ path: '/orders', query: to.query })
    },
    {
        path: '/my',
        name: 'my',
        component: () => import('@/vue-pages/pages/my'), // 我的
        meta: {
            title: '我的',
            keepAlive: true
        }
    },
    {
        path: '/product_all',
        name: 'product_all',
        component: () => import('@/vue-pages/pages/product_all'), // 全部商品
        meta: {
            title: '全部商品'
        }
    },
    {
        path: '/detail',
        name: 'detail',
        component: () => import('@/vue-pages/pages/detail'), // 详情
        meta: {
            title: '详情',
            keepAlive: true
        }
    },
    {
        path: '/search',
        name: 'search',
        component: () => import('@/vue-pages/pages/search'), // 搜索
        meta: {
            title: '搜索'
        }
    },
    {
        path: '/complaint',
        name: 'complaint',
        component: () => import('@/vue-pages/pages/complaint'), // 投诉
        meta: {
            title: '投诉'
        }
    },
    {
        path: '/submit_complaint',
        name: 'submit_complaint',
        component: () => import('@/vue-pages/pages/submit_complaint'), // 投诉提交
        meta: {
            title: '投诉提交'
        }
    },
    {
        path: '/complaint_record',
        name: 'complaint_record',
        component: () => import('@/vue-pages/pages/complaint_record'), // 投诉记录
        meta: {
            title: '投诉记录'
        }
    },
    {
        path: '/my_coupon',
        name: 'my_coupon',
        component: () => import('@/vue-pages/pages/my_coupon'), // 我的优惠券
        meta: {
            title: '我的优惠券',
             keepAlive: true
        }
    },
    {
        path: '/integral',
        name: 'integral',
        component: () => import('@/vue-pages/pages/integral'), // 积分
        meta: {
            title: '积分'
        }
    },
    {
        path: '/integral_rule',
        name: 'integral_rule',
        component: () => import('@/vue-pages/pages/integral_rule'), // 积分规则
        meta: {
            title: '积分规则'
        }
    },
    {
        path: '/user_agreement',
        name: 'user_agreement',
        component: () => import('@/vue-pages/pages/user_agreement'), // 用户协议
        meta: {
            title: '用户协议'
        }
    },
    {
        path: '/privacy_policy',
        name: 'privacy_policy',
        component: () => import('@/vue-pages/pages/privacy_policy'), // 隐私条款
        meta: {
            title: '隐私条款'
        }
    },
    {
        path: '/about_us',
        name: 'about_us',
        component: () => import('@/vue-pages/pages/about_us'), // 关于我们
        meta: {
            title: '关于我们'
        }
    },
    {
        path: '/web_letter',
        name: 'web_letter',
        component: () => import('@/vue-pages/pages/web_letter'), // 站内信
        meta: {
            title: '站内信'
        }
    },
    {
        path: '/about_info',
        name: 'about_info',
        component: () => import('@/vue-pages/pages/about_info'), // 关于我们
        meta: {
            title: '关于我们'
        }
    },
    {
        path: '/system_service',
        name: 'system_service',
        component: () => import('@/vue-pages/pages/system_service'), // 自有客服
        meta: {
            title: '客服'
        }
    },
    {
        path: '/customer_service',
        name: 'customer_service',
        component: () => import('@/vue-pages/pages/customer_service'), // 客服通道
        meta: {
            title: '客服通道'
        }
    },
    {
        path: '/qiyu_service',
        name: 'qiyu_service',
        component: () => import('@/vue-pages/pages/qiyu_service'), // 七鱼客服
        meta: {
            title: '客服'
        }
    },
    {
        path: '/qiyu_services',
        name: 'qiyu_services',
        component: () => import('@/vue-pages/pages/qiyu_services'), // 七鱼客服
        meta: {
            title: '客服'
        }
    },
    {
        path: '/download_app',
        name: 'download_app',
        component: () => import('@/vue-pages/pages/download_app'), // 下载APP
        meta: {
            title: '下载APP'
        }
    },
    {
        path: '/topic_detail',
        name: 'topic_detail',
        component: () => import('@/vue-pages/pages/topic_detail'), // 专题详情
        meta: {
            title: '专题详情'
        }
    },
    {
        path: '/re_charge',
        name: 're_charge',
        component: () => import('@/vue-pages/pages/re_charge'), // 充值中心
        meta: {
            title: '钱包充值'
        }
    },
    {
        path: '/re_charge_order',
        name: 're_charge_order',
        component: () => import('@/vue-pages/pages/re_charge_order'), // 充值订单
        meta: {
            title: '充值订单'
        }
    },
    {
        path: '/game_circle',
        name: 'game_circle',
        component: () => import('@/vue-pages/pages/game_circle'), // 游戏圈
        meta: {
            title: '游戏圈',
            keepAlive: true
        }
    },
    {
        path: '/game_circle_detail',
        name: 'game_circle_detail',
        component: () => import('@/vue-pages/pages/game_circle_detail'), // 游戏圈详情
        meta: {
            title: '帖子详情'
        }
    },
    {
        path: '/game_circle_publish',
        name: 'game_circle_publish',
        component: () => import('@/vue-pages/pages/game_circle_publish'), // 发布帖子
        meta: {
            title: '发布帖子'
        }
    },
    {
        path: '/message',
        name: 'message',
        component: () => import('@/vue-pages/pages/message'), // 消息列表
        meta: {
            title: '游戏圈消息',
            keepAlive: true
        }
    },
    {
        path: '/my_posts',
        name: 'my_posts',
        component: () => import('@/vue-pages/pages/my_posts'), // 我的帖子
        meta: {
            title: '我的帖子',
            keepAlive: true
        }
    },
    {
        path: '/comment_manage',
        name: 'comment_manage',
        component: () => import('@/vue-pages/pages/comment_manage'), // 管理评论
        meta: {
            title: '管理评论',
            keepAlive: true
        }
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/home',
        component: () => import('@/vue-pages/pages/home') // 默认路由+
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    }
})

router.beforeEach((to, from, next) => {
    // 修改页面title
    if (to.meta.title) {
        var web = sessionStorage.getItem('web')
        if (web) {
            var web_ = JSON.parse(web)
            document.title = web_.web_name + '-' + to.meta.title
        } else {
            document.title = to.meta.title
        }
    }
    
    // 动态设置 keepAlive
    if (to.name === 'my_coupon') {
        // 从底部导航栏进入（有 type 参数）时设置 keepAlive 为 true
        // 从我的页面进入（无 type 参数）时设置 keepAlive 为 false
        to.meta.keepAlive = to.query.type !== undefined && to.query.type !== ''
    }
    
    next()
})

export default router
